import React, { memo } from 'react';
import { Routes, Route } from 'react-router';
import { ROUTES } from '../routes';

import LazyRouteContent from 'components/LazyRouteContent';
import { RouteOnMount } from 'utils/routes';

const AppRouter = memo(() => {
    return (
        <Routes>
            {ROUTES.map((route) => (
                <Route
                    key={route.path}
                    path={route.path}
                    element={
                        <RouteOnMount
                            {...route}
                            element={<LazyRouteContent>{route.element}</LazyRouteContent>}
                        />
                    }
                />
            ))}
        </Routes>
    );
});

AppRouter.displayName = 'AppRouter';

export default AppRouter;
